/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Launch/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Launch({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Launch",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Launch.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZuAw3y': alignSelf,'--mt-2-ZuAw3y': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZuAw3y': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZuAw3y': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZuAw3y': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZuAw3y': opacity,'--w-10-ZuAw3y': typeof width === 'number' ? `${width}px` : width,'--h-11-ZuAw3y': typeof height === 'number' ? `${height}px` : height,'--f-12-ZuAw3y': fill,'--a-7-ZuAw3y': isAnimated ? animation : "none",'--sd-8-ZuAw3y': isAnimated ? strokeDashoffset : 0,'--sd-9-ZuAw3y': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Launch.SvgPath"
  data-view-path={viewPath}
 d="M17 13.429v6.428a1.43 1.43 0 01-1.429 1.429H4.142a1.429 1.429 0 01-1.428-1.429V8.43A1.429 1.429 0 014.142 7h6.429M16.286 2.714h5v5M21.286 2.714l-7.857 7.857"
 strokeWidth={1.5}
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-ZuAw3y': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}